module.exports = __webpack_public_path__ + "static/img/BestOf_E-Commerce_2018.417592c.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/img/BestOf_E-Commerce_2018.png
// module id = Avp5
// module chunks = 1